// extracted by mini-css-extract-plugin
export default {"wrap":"PageSizeSelect_wrap__odcb9","label":"PageSizeSelect_label__rvAv1","select":"PageSizeSelect_select__JC2OJ"};